import axios from 'axios';
import Config from '../../Config';

class SendersRequest {
  
  static getToken() {
    return localStorage.getItem('dealboxx_token');
  }

  static async getAllSenders() {
    try {
      const response = await axios.get(`${Config.backendDomain}vendor/vendorSenderId`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  static async createSender(senderData) {
    try {
      const response = await axios.post(`${Config.backendDomain}vendor/senderId`, senderData, {
        headers: {
          'Authorization': `Bearer ${this.getToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  static async updateSender(senderId, senderData) {
    try {
      const response = await axios.patch(`${Config.backendDomain}vendor/senderId/${senderId}`, senderData, {
        headers: {
          'Authorization': `Bearer ${this.getToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  static async deleteSender(senderId) {
    try {
      const response = await axios.delete(`${Config.backendDomain}vendor/senderId/${senderId}`, {
        headers: {
          'Authorization': `Bearer ${this.getToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  static handleError(error) {
    if (error.response) {
      return {
        status: error.response.status,
        message: error.response.data.message || 'An error occurred',
        error: error.response.data
      };
    } else if (error.request) {
      // Request made but no response
      return {
        status: 503,
        message: 'Service unavailable. Please try again later.',
        error: error.request
      };
    } else {
      // Error in request setup
      return {
        status: 500,
        message: 'Failed to make request',
        error: error.message
      };
    }
  }
}

export default SendersRequest;
